import { SecondaryButton } from "@shared/buttons";

export const StatusFilterForm = () => {
  const isAllSelected = false;

  return (
    <>
      <label className="flex items-center cursor-pointer">
        <input
          className="nb-input"
          type="checkbox"
          checked={isAllSelected}
          // onChange={onToggleAll}
        />
        <span className="font-normal ml-1 px-2">
          {isAllSelected ? "Unselect All" : "Select All"}
        </span>
      </label>
      <label className="flex items-center cursor-pointer">
        <input
          className="nb-input"
          type="checkbox"
          // checked={proposedStatusFilters.has(CreativesStatusEnum.active)}
          // onChange={() => {
          //   onToggle(CreativesStatusEnum.active);
          // }}
        />
        <span className="text-[#3B8139] font-normal bg-alien-2 ml-2 px-2 py-0.5 rounded">
          Active
        </span>
      </label>
      <label className="flex items-center cursor-pointer">
        <input
          className="nb-input"
          // checked={proposedStatusFilters.has(CreativesStatusEnum.inactive)}
          type="checkbox"
          // onChange={() => onToggle(CreativesStatusEnum.inactive)}
        />
        <span className="font-normal bg-interstellar-3 ml-2 px-2 py-0.5 rounded">
          Inactive
        </span>
      </label>
      <div className="mt-5 flex gap-2">
        <SecondaryButton
          className="flex-1 font-semibold"
          // onClick={() => {
          //   onReset();
          //   onClose();
          // }}
        >
          {/* {currentStatuses ? "RESET" : "CANCEL"} */}
          TODO
        </SecondaryButton>
        <SecondaryButton
          className="flex-1 font-semibold"
          // isDisabled={
          //   (!currentStatuses || currentStatuses.length === 0) &&
          //   proposedStatusFilters.size === 0
          // }
          // onClick={() => {
          //   onApply(
          //     proposedStatusFilters ? Array.from(proposedStatusFilters) : null,
          //   );
          //   onClose();
          // }}
        >
          APPLY
        </SecondaryButton>
      </div>
    </>
  );
};
